import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

import { routes } from './app.routes';
import { provideIMCAuth } from './auth/auth.config';
import { authInterceptor } from './auth/interceptors/auth.interceptor';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    }),
    provideIMCAuth({
      apiUrl: environment.apiUrl,
      azureAD: {
        clientId: environment.azureAD.clientId,
        tenantId: environment.azureAD.tenantId
      },
      loginRoute: '/login',
      sessionTimeoutMinutes: 120
    })
  ]
};
